module.exports = __webpack_public_path__ + "static/media/ffstars-Bulgaria-icon_512x512.de886877.png";